export default "__VITE_ASSET__CGOO4fC___"